import React from 'react';
import styled from 'styled-components';
import seagull from '../assets/images/barrel-seagull.jpeg';
import boxes from '../assets/images/bbb-boxes.png';
import gravestone from '../assets/images/graveStone.jpeg';
import logo from '../assets/images/logo-white-background.jpeg';
import wrappingPaper from '../assets/images/wrapping-paper.png';
import map from '../assets/images/njurunda-map.png';

const ImageGallery = (): JSX.Element => {
  return (
    <ImageGalleryWrapper>
      <Image src={seagull} />
      <Image src={boxes} />
      <Image src={gravestone} />
      <Image src={logo} />
      <Image src={wrappingPaper} />
      <Image src={map} />
    </ImageGalleryWrapper>
  );
};

const ImageGalleryWrapper = styled.div`
  background-color: #bf7b23;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(6, 30vh);
  grid-gap: 2rem;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (min-width: 769px) {
    grid-template-columns: auto auto auto;
    grid-template-rows: 40vh 40vh;
    padding: 2rem;
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;

  @media (min-width: 769px) {
    height: 100%;
    width: 100%;
  }
`;

export default ImageGallery;
